import {
  createDirectus,
  rest,
  readItems,
  createItem,
  updateItem,
  deleteItem,
  readItem,
  aggregate,
  updateItems,
  authentication,
} from "@directus/sdk";

const client = createDirectus(location.origin)
  .with(authentication("cookie"))
  .with(rest());

async function get(limit, offset, filter, sort, fields) {
  let query = {
    limit,
    offset,
    fields: fields
      ? fields
      : [
          "*,groups.groups_id.*,person_id.*,companies.*,contacts.*,contacts.person_id.*,companies.*,companies.companies_id.*",
        ],
  };
  if (sort) query.sort = sort;
  if (Object.keys(filter).length !== 0) {
    query.filter = filter;
  }

  const totalCount = await client.request(
    aggregate("agents", {
      aggregate: { count: "*" },
      query: { filter },
    })
  );

  const data = await client.request(readItems("agents", query));
  return { totalCount: totalCount[0].count, data };
}

async function getGroupsByIds(ids) {
  let obj = {
    filter: { agent_id: { _in: ids } },
  };
  const data = await client.request(readItems("agent_groups", obj));

  return data;
}
async function getId(filter) {
  let obj = {
    limit: 1,
    filter,
    fields: ["Id"],
  };
  return await client.request(readItems("agents", obj));
}
async function getById(id) {
  return await client.request(
    readItem("agents", id, {
      fields: [
        "*,groups.groups_id.*,person_id.*,companies.*,companies.companies_id.*,contacts.*,contacts.person_id.*",
      ],
    })
  );
}

async function create(data) {
  let person_id = "";
  if (data.person_id) person_id = data.person_id;
  else {
    const person = await client.request(
      createItem("persons", {
        name: data.name,
        email: data.email,
        phone: data.phone,
        birthday: data.birthday,
        address: data.address,
        comment: data.comment,
      })
    );
    person_id = person.id;
  }
  return await client.request(
    createItem(
      "agents",
      {
        person_id: person_id,
        priority: data.priority,
        groups: data.groups,
        companies: data.companies,
        contacts: data.contacts,
      },
      {
        fields: [
          "*,groups.groups_id.*,person_id.*,companies.*,companies.companies_id.*,contacts.*,contacts.person_id.*",
        ],
      }
    )
  );
}

async function updateById(id, data) {
  if (!data.person_id) {
    const person = await client.request(
      createItem("persons", {
        name: data.name,
        email: data.email,
        phone: data.phone,
        birthday: data.birthday,
        address: data.address,
        comment: data.comment,
      })
    );
    data.person_id = person.id;
  } else {
    await client.request(
      updateItem("persons", data.person_id, {
        name: data.name,
        email: data.email,
        phone: data.phone,
        birthday: data.birthday,
        address: data.address,
        comment: data.comment,
      })
    );
  }
  return await client.request(
    updateItem(
      "agents",
      id,
      {
        person_id: data.person_id,
        priority: data.priority,
        groups: data.groups,
        companies: data.companies,
        contacts: data.contacts,
      },
      {
        fields: [
          "*,groups.groups_id.*,person_id.*,companies.*,companies.companies_id.*,contacts.*,contacts.person_id.*",
        ],
      }
    )
  );
}

async function update(items, data) {
  return await client.request(
    updateItems("agents", items, data, { fields: ["*,groups.*"] })
  );
}

async function deleteById(id) {
  return await client.request(deleteItem("agents", id));
}
export default {
  get,
  create,
  update,
  deleteById,
  getById,
  updateById,
  getGroupsByIds,
  getId,
};
